import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { Link } from "../../../../components/wpl/link/src/index";

const backgroundStyle = css({
    fontFamily: "var(--bxp-charlie-display-font-family)",
    letterSpacing: "0.3px",
    display: "flex",
    textAlign: "center",
    margin: "16px",
    borderRadius: "3px",
    [media.above.lg]: {
        flexDirection: "row",
        alignItems: "flex-start",
        padding: "35px 218px 35px 268px",
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_bg_lu.webp)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "100% 100%"
    },
    [media.only.md]: {
        flexDirection: "column",
        padding: "48px 32px 32px 32px",
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_tablet_bg.webp)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "100% 100%"
    },
    [media.only.sm]: {
        flexDirection: "column",
        padding: "48px 32px 32px 32px",
        backgroundImage:
            "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/wac_lifted_bar_tablet_bg.webp)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "100% 100%"
    },
    [media.below.sm]: {
        flexDirection: "column",
        padding: "32px 32px 16px 32px",
        background: "#ebf2fd"
    }
});

const headerStyle = css({
    margin: "0px 16px 0px 16px",
    textAlign: "center",
    lineHeight: "1.33333333",
    fontWeight: 500,
    fontSize: "1.5rem",
    [media.above.lg]: {
        display: "none"
    }
});

const lgHeaderStyle = css({
    fontWeight: 500,
    lineHeight: "1.33333333",
    textAlign: "left",
    [media.below.lg]: {
        display: "none"
    }
});

const descriptionStyle = css({
    lineHeight: "1.33333333",
    fontWeight: "400",
    [media.above.lg]: {
        flexBasis: "45%",
        textAlign: "left"
    },
    [media.only.md]: {
        margin: "0px 80px 0px 80px",
        fontSize: "1.3rem"
    },
    [media.only.sm]: {
        margin: "0px 80px 0px 80px",
        fontSize: "1.3rem"
    },
    [media.below.sm]: {
        margin: "0px 12px 0px 12px",
        fontSize: "1.25rem"
    }
});

const linkStyle = css({
    fontSize: "1.1rem",
    [media.above.lg]: {
        flexBasis: "25%",
        padding: "40px 0px 0px 50px"
    }
});

const emptyDivStyle = css({
    [media.above.lg]: {
        flexBasis: "30%"
    }
});

export const TeamBanner = () => {
    const intl = useIntl();
    const header = (
        <FormattedMessage
            id="LiftedBar.Team.24.header"
            defaultMessage={`Our annual conference is back in Las Vegas!`}
        />
    );
    const description = (
        <FormattedMessage
            id="LiftedBar.Team.24.description"
            defaultMessage={`Be the first to see our latest innovations. For a limited time only, save $1000 on your all-access pass.`}
        />
    );
    const linkText = intl.formatMessage({
        id: "LiftedBar.Team.24.link",
        defaultMessage: "Register now"
    });

    const url =
        "https://events.atlassian.com/team?ref=Team_24&utm_source=marketing&utm_campaign=acquisition&utm_content=outreach&utm_medium=home_page_banner";

    return (
        <div css={backgroundStyle}>
            <div css={emptyDivStyle}> </div>
            <div css={headerStyle}>
                <span>{header}</span>
            </div>
            <div css={descriptionStyle}>
                <div css={lgHeaderStyle}>
                    <span>{header}</span>
                </div>
                <p>{description}</p>
            </div>
            <div css={linkStyle}>
                <Link
                    href={url}
                    text={linkText}
                    type="basic-underline"
                    customLinkColor="#0052cc"
                    doesArrowAnimate={true}
                    dataEventProps={{
                        "data-event-component": "linkButton",
                        "data-event-container": "banner-link-button",
                        "data-event": "clicked",
                        "data-product-key": "jiraSoftware"
                    }}
                />
            </div>
        </div>
    );
};
